<template>
  <div class="bg-gray-50 px-4 py-3 sm:px-6 border-b border-gray-200 flex flex-wrap items-center justify-between gap-4">
    <div class="relative w-full sm:w-auto">
      <label for="search" class="sr-only">Search</label>
      <div class="relative">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
          </svg>
        </div>
        <input
          id="search"
          :value="searchQuery"
          @input="$emit('update:searchQuery', $event.target.value)"
          type="text"
          placeholder="Search RFIs..."
          class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
        />
      </div>
    </div>

    <div class="flex flex-wrap gap-3">
      <div class="flex flex-wrap gap-3 items-center" v-if="rfisRequested.length > 0 || rfisDirected.length > 0">
        <div class="flex items-center">
          <span class="mr-2 text-sm text-gray-700">View:</span>
          <button
            @click="$emit('update:activeView', 'requested')"
            :class="[
              activeView === 'requested'
                ? 'bg-brand-700 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-50',
              'px-3 py-1 text-sm rounded-l-md border border-gray-300',
            ]"
          >
            Requested By Me
          </button>
          <button
            @click="$emit('update:activeView', 'directed')"
            :class="[
              activeView === 'directed'
                ? 'bg-brand-700 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-50',
              'px-3 py-1 text-sm rounded-r-md border border-gray-300 border-l-0',
            ]"
          >
            Directed To Me
          </button>
        </div>
      </div>
      
      <select
        :value="priorityFilter"
        @change="$emit('update:priorityFilter', $event.target.value)"
        class="block w-full sm:w-auto pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm rounded-md"
      >
        <option value="">All Statuses</option>
        <option v-for="status in statuses" :key="status" :value="status">
          {{ status }}
        </option>
      </select>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchQuery: String,
    priorityFilter: String,
    disciplineFilter: String,
    activeView: String,
    rfisRequested: Array,
    rfisDirected: Array,
    statuses: Array,
    disciplines: Array
  },
  emits: ['update:searchQuery', 'update:priorityFilter', 'update:disciplineFilter', 'update:activeView']
}
</script>